import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext'
import generateUUID from 'Utils/generateUUID'
import { useSelector } from 'react-redux'
import { formatToCents } from 'Utils/convertPoints'
import { deleteCookie, getCookie } from 'Utils/handleCookie'

const CreateBraspagInput = ({
  setIsLoadingBraspagConfirmationModal,
  customer,
  billingAddress,
  debitCard,
  paymentPoints,
  setIsLoadingBraspagInput,
  handlePurchaseDebit,
  handleShowError
}) => {
  const [accessToken, setAccessToken] = useState(null)
  const [isBraspagAuthorizeError, setIsBraspagAuthorizeError] = useState(false)

  let bpContainerAuthenticate = document.createElement('div')
  bpContainerAuthenticate.setAttribute('id', 'bp_container_authenticate')

  const phoneNumber = customer.phone || ''
  const formatToCent = formatToCents(paymentPoints || 0)

  const validityDateParts = debitCard.validityDate.split('/')
  const expirationMonth = validityDateParts[0]
  const expirationYear = validityDateParts[1]

  deleteCookie('braspagAuthenticationInfos');
  deleteCookie('BraspagErrorInfo');

  const getCardNumber = () => {
    const onlyNumbers = debitCard.number.match(/\d+/g)
    if (onlyNumbers) return onlyNumbers.join([])
    return ''
  }

  const cardNumber = getCardNumber()

  const AuthorizationBraspag = useSelector(({ AuthorizationBraspag: data }) => data);
  const { callApi } = usePipeContext()

  //Ao carregar o componente, chamaremos a API
  useEffect(() => {
    //Bater no endpoint da braspag
    callApi({
      symbol: 'FETCH_BRASPAG_AUTHORIZATION',
      alias: generateUUID()
    });
  }, [])

  useEffect(() => {
    if (AuthorizationBraspag?.finishRequests && !AuthorizationBraspag?.isError) {
        setAccessToken(AuthorizationBraspag.authorizationBraspag.access_token)
        setIsLoadingBraspagInput(false); //Apenas para liberar os botões de compra
    } else if (AuthorizationBraspag?.isError) {
      setIsBraspagAuthorizeError(false)
      window.location.reload(); // REQUISITO
    }
  }, [AuthorizationBraspag?.finishRequests])


  useEffect(() => {
    let braspagAutheticationInfoInterval, braspagErrorInfoInterval;

    if (AuthorizationBraspag?.finishRequests) {
      braspagAutheticationInfoInterval = setInterval(() => {
        const rawBraspag = getCookie('braspagAuthenticationInfos');
        const braspagAuthenticationInfos = JSON.parse(rawBraspag);

        if (braspagAuthenticationInfos) {
          setIsLoadingBraspagConfirmationModal(false);
          clearInterval(braspagAutheticationInfoInterval);
          handlePurchaseDebit(braspagAuthenticationInfos);
        }

      }, 1000);

      braspagErrorInfoInterval = setInterval(() => {
        const rawBraspagErrorInfo = getCookie('BraspagErrorInfo');
        setIsLoadingBraspagConfirmationModal && setIsLoadingBraspagConfirmationModal(false);
        rawBraspagErrorInfo && handleShowError(rawBraspagErrorInfo);
      }, 1000);
    }

    return () => {
      clearInterval(braspagAutheticationInfoInterval);
      clearInterval(braspagErrorInfoInterval);
    };
  }, [AuthorizationBraspag?.finishRequests, AuthorizationBraspag?.isError]); //Alterar para finishRequests && hasError

  const getMerchantUrl = () => {
    const rawUrl = window.location.href;
    const urlObject = new URL(rawUrl);
    return urlObject.origin;
  };

  return (AuthorizationBraspag?.finishRequests && accessToken) && (
    <div id='bp_container_authenticate'>
      <input name='authEnabled' className='bpmpi_auth' type='hidden' value='true' />
      <input
        name='accessToken'
        className='bpmpi_accesstoken'
        type='hidden'
        value={accessToken}
      />
      <input name='orderNumber' className='bpmpi_ordernumber' type='hidden' value='123456' />
      <input name='currency' className='bpmpi_currency' type='hidden' value='BRL' />
      <input name='amount' className='bpmpi_totalamount' type='hidden' value={formatToCent.toString()} />
      <input name='installments' className='bpmpi_installments' type='hidden' value='1' />
      <input name='paymentMethod' className='bpmpi_paymentmethod' type='hidden' value='Debit' />
      <input name='cardNumber' className='bpmpi_cardnumber' type='hidden' value={cardNumber} />
      <input name='expMonth' className='bpmpi_cardexpirationmonth' type='hidden' value={expirationMonth} />
      <input name='expYear' className='bpmpi_cardexpirationyear' type='hidden' value={expirationYear} />
      <input name='newCustomer' className='bpmpi_merchant_newcustomer' type='hidden' value='debit' />
      <input name='name' className='bpmpi_billto_name' type='hidden' value={customer.name} />
      <input name='phoneNumber' className='bpmpi_billto_phonenumber' type='hidden' value={phoneNumber} />
      <input name='email' className='bpmpi_billto_email' type='hidden' value={customer.email} />
      <input name='street1' className='bpmpi_billto_street1' type='hidden' value={billingAddress && billingAddress.street ? billingAddress.street : ''} />
      <input name='street2' className='bpmpi_billto_street2' type='hidden' value={billingAddress && billingAddress.complement ? billingAddress.complement : ''} />
      <input name='city' className='bpmpi_billto_city' type='hidden' value={billingAddress && billingAddress.city ? billingAddress.city : ''} />
      <input name='state' className='bpmpi_billto_state' type='hidden' value={billingAddress && billingAddress.state ? billingAddress.state : ''} />
      <input name='country' className='bpmpi_billto_country' type='hidden' value='BR' />
      <input name='zipcode' className='bpmpi_billto_zipcode' type='hidden' value={billingAddress && billingAddress.zipCode ? billingAddress.zipCode : ''} />
      <input name='merchantUrl' className='bpmpi_merchant_url' type='hidden' value={getMerchantUrl()} />
    </div>
  )
}

CreateBraspagInput.propTypes = {
  customer: PropTypes.object,
  billingAddress: PropTypes.object,
  debitCard: PropTypes.object,
  paymentPoints: PropTypes.number,
  setIsLoadingBraspagInput: PropTypes.func,
  handlePurchaseDebit: PropTypes.func
}

export default CreateBraspagInput
